<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    color: '#666666',
  }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <path
        id="Vector"
        d="M11.8 7.60039H17.2V6.89719C17.2001 6.73081 17.1771 6.56523 17.1316 6.40519L17.1304 6.40039C17.0461 6.10745 16.8888 5.84071 16.6732 5.62519L11.9752 0.927191C11.6378 0.589969 11.1803 0.400492 10.7032 0.400391H5.2C4.56348 0.400391 3.95303 0.653247 3.50295 1.10333C3.05286 1.55342 2.8 2.16387 2.8 2.80039V17.2004C2.8 17.8369 3.05286 18.4474 3.50295 18.8974C3.95303 19.3475 4.56348 19.6004 5.2 19.6004H7.8652L7.8496 19.5692C7.66272 19.2093 7.57766 18.8051 7.6036 18.4004H5.2C4.88174 18.4004 4.57652 18.274 4.35148 18.0489C4.12643 17.8239 4 17.5187 4 17.2004V2.80039C4 2.48213 4.12643 2.17691 4.35148 1.95186C4.57652 1.72682 4.88174 1.60039 5.2 1.60039H10V5.80039C10 6.27778 10.1896 6.73562 10.5272 7.07318C10.8648 7.41075 11.3226 7.60039 11.8 7.60039ZM11.8 6.40039C11.6409 6.40039 11.4883 6.33718 11.3757 6.22465C11.2632 6.11213 11.2 5.95952 11.2 5.80039V1.84879L15.7516 6.40039H11.8ZM15.772 9.45799C15.9798 9.24701 16.2274 9.07924 16.5003 8.96438C16.7733 8.84951 17.0663 8.78981 17.3624 8.78872C17.6586 8.78763 17.952 8.84517 18.2258 8.95802C18.4996 9.07088 18.7484 9.23681 18.9577 9.44626C19.1671 9.6557 19.333 9.90452 19.4457 10.1784C19.5584 10.4522 19.6159 10.7457 19.6147 11.0418C19.6135 11.338 19.5537 11.6309 19.4387 11.9039C19.3237 12.1768 19.1559 12.4243 18.9448 12.632L13.1488 18.4268C12.8112 18.7646 12.3881 19.0043 11.9248 19.1204L10.1272 19.5692C9.94846 19.6137 9.76124 19.6113 9.58372 19.5621C9.4062 19.5129 9.24442 19.4186 9.11411 19.2884C8.98379 19.1582 8.88937 18.9965 8.84 18.8191C8.79064 18.6416 8.78802 18.4544 8.8324 18.2756L9.2824 16.478C9.3975 16.0143 9.63737 15.591 9.976 15.254L15.772 9.45799Z"
        :fill="props.color"
      />
    </g>
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
